import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const dark = ({ palette, fontSizes, fontWeights }: Pick<Theme, 'palette' | 'fontWeights' | 'fontSizes'>, background?: string) => ({
  padding: '0.75rem 1.25rem',
  background: background || `${palette.primary.dark}`,
  color: palette.common.white,
  fontSize: fontSizes.sm,
  fontWeight: fontWeights.medium,
  lineHeight: 1.5,
  justifyContent: 'center',
  borderRadius: '1rem',
  '&:focus-visible': {
    outlineColor: background || palette.primary.dark,
  },
  '&:disabled': {
    background: `${palette.grey['400']}`,
    pointerEvents: 'none',
  },
});

const outlined = ({ palette, fontSizes, fontWeights }: Pick<Theme, 'palette' | 'fontWeights' | 'fontSizes'>, background?: string) => ({
  justifyContent: 'center',
  width: 'fit-content',
  padding: '0.675rem 1.25rem',
  border: `2px solid ${background || palette.primary.dark}`,
  borderRadius: '1rem',
  background: palette.common.white,
  color: background || palette.primary.dark,
  fontSize: fontSizes.sm,
  fontWeight: fontWeights.medium,
  lineHeight: 1.5,
  '&:focus-visible': {
    outlineColor: background || palette.primary.dark,
  },
});

export const useStyles = makeStyles(({
  breakpoints,
  palette,
  fontSizes,
  fontWeights,
  fontFamilies,
  borderRadiuses,
}: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    border: 'none',
    fontFamily: fontFamilies.primary,
    lineHeight: 1.4,
    textDecoration: 'none',
    textTransform: 'unset',
    cursor: 'pointer',
    [breakpoints.up('md')]: {
      padding: '0.75rem 1.5rem',
    },
    '&:focus-visible': {
      outlineWidth: 1,
      outlineStyle: 'dashed',
      outlineOffset: 2,
    },
    '&.primary': {
      justifyContent: 'center',
      padding: '0.75rem 1.25rem',
      borderRadius: '0.75rem',
      background: palette.custom.main,
      color: palette.common.white,
      fontSize: fontSizes.sm,
      lineHeight: 1.5,
      fontWeight: fontWeights.medium,
      '&:focus-visible': {
        outlineColor: palette.primary.dark,
      },
    },
    '&.light': {
      justifyContent: 'center',
      padding: '0.75rem 1.25rem',
      borderRadius: borderRadiuses.lg,
      background: palette.common.white,
      color: palette.primary.dark,
      fontSize: fontSizes.sm,
      lineHeight: 1.5,
      fontWeight: fontWeights.medium,
      '&:focus-visible': {
        outlineColor: palette.common.white,
      },
    },
    '&.text': {
      width: 'fit-content',
      padding: 0,
      borderRadius: 0,
      background: 'transparent',
      color: palette.primary.dark,
      fontSize: fontSizes.sm,
      lineHeight: 1.25,
      [breakpoints.up('md')]: {
        width: 'fit-content',
      },
      '&:focus-visible': {
        outlineColor: palette.primary.dark,
      },
    },
    '&.dark': dark({ palette, fontSizes, fontWeights }),
    '&.darker': dark({ palette, fontSizes, fontWeights }, palette.info.dark),
    '&.cv': dark({ palette, fontSizes, fontWeights }, palette.secondary.dark),
    '&.outlined': outlined({ palette, fontSizes, fontWeights }),
    '&.cv-outlined': outlined({ palette, fontSizes, fontWeights }, palette.secondary.dark),
  },
  isUnderline: {
    textDecoration: 'underline',
  },
}));
